import styled from 'styled-components'
import RoomChargeIcon from '../../../../img/svg/roomCharge'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const SearchTabs = styled.div`
	display: flex;
	height: 4.18em;
	padding: 0.31em;
	border-radius: 0.75em;
	background: ${colorTheme.roomCharge.modal.tab.background};
`
SearchTabs.displayName = 'SearchTabs'

export const SearchTab = styled.button`
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
	gap: 0.33em;
	padding: 0 0.83em;
	border: 1px solid transparent;
	border-radius: 0.55em;
	font-size: 1.12em;
	font-weight: 500;
	transition: all 0.2s;
	background: ${colorTheme.roomCharge.modal.tab.background};
	color: ${colorTheme.roomCharge.modal.tab.text};

	&.active {
		border-color: ${colorTheme.roomCharge.modal.tab.active.border};
		background: ${colorTheme.roomCharge.modal.tab.active.background};
		color: ${colorTheme.roomCharge.modal.tab.active.text};
	}
`
SearchTab.displayName = 'SearchTab'

export const SearchTabIcon = styled(RoomChargeIcon)`
	width: 0.88em;
	height: 0.88em;
`
SearchTabIcon.displayName = 'SearchTabIcon'

export const SearchFieldGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.62em;
`
SearchFieldGroup.displayName = 'SearchFieldGroup'

export const SearchFieldLabel = styled.span`
	font-size: 1.12em;
	color: ${colorTheme.roomCharge.modal.label};
`
SearchFieldLabel.displayName = 'SearchFieldLabel'

export const SearchFieldBox = styled.div`
	overflow: hidden;
	border: 1px solid ${colorTheme.roomCharge.modal.field.border};
	border-radius: 0.75em;

	&.error {
		border-color: ${colorTheme.roomCharge.modal.field.error.border};
	}
`
SearchFieldBox.displayName = 'SearchFieldBox'

export const SearchFieldError = styled.p`
	padding: 0.25em 0.93em;
	font-size: 0.87em;
	font-weight: 500;
	background: ${colorTheme.roomCharge.modal.field.error.background};
	color: ${colorTheme.roomCharge.modal.field.error.text};
`
SearchFieldError.displayName = 'SearchFieldError'

export const SearchFieldValueRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.93em;
	height: 3.43em;
	padding: 0 1.06em;
	background: ${colorTheme.roomCharge.modal.field.background};
`
SearchFieldValueRow.displayName = 'SearchFieldValueRow'

export const SearchFieldValue = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 2em;
	line-height: 1;
	color: ${colorTheme.roomCharge.modal.field.text};

	&.spaced {
		letter-spacing: 0.25em;
	}
`
SearchFieldValue.displayName = 'SearchFieldValue'

export const SearchFieldDot = styled.span`
	width: 0.43em;
	height: 0.43em;
	border-radius: 50%;
	background: ${colorTheme.roomCharge.modal.field.placeholder};
`
SearchFieldDot.displayName = 'SearchFieldDot'

export const SearchFieldInput = styled.input`
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	border: none;
	outline: none;
	font-size: 2em;
	line-height: 1;
	text-align: left;
	background: transparent;
	color: ${colorTheme.roomCharge.modal.field.text};

	&::placeholder {
		color: ${colorTheme.roomCharge.modal.field.placeholder};
	}
`
SearchFieldInput.displayName = 'SearchFieldInput'

export const SearchFieldKeyboardButton = styled.button`
	display: grid;
	place-items: center;
	flex-shrink: 0;
	width: 2em;
	height: 2em;
	background: transparent;

	> img {
		width: 100%;
		height: 100%;
	}
`
SearchFieldKeyboardButton.displayName = 'SearchFieldKeyboardButton'
